
import { AudioInfoRawData } from "../../model/audio/AudioInfo.js";
import { MediaInfoRawData } from "../../model/MediaInfo.js";
import { VideoInfoRawData } from "../../model/video/VideoInfo.js";
import { CursoredPlaylist } from "./CursoredPlaylist.js";



export type MediaElementTransformer<MI extends MediaInfoRawData<any>> = (data: MI) => MI | null

export type VideoElementTransformer = MediaElementTransformer<VideoInfoRawData>
export type AudioElementTransformer = MediaElementTransformer<AudioInfoRawData>

function cloneMedia<MI extends MediaInfoRawData<any>>(v: MI): MI {
    return JSON.parse(JSON.stringify(v));
}

function cumulativeTransformer<MI extends MediaInfoRawData<any>>(transformers: MediaElementTransformer<MI>[], media: MI): MI | null {

    return transformers.reduce((data, transformer) => {
        if (data) return transformer(data);
        else return null;
    }, cloneMedia(media));
}

export function applyPlaylistTransformers<MI extends MediaInfoRawData<any>>(transformers: MediaElementTransformer<MI>[], medias: MI[]): MI[] {
    const nuMedias: MI[] = [];
    medias.forEach(vid => {
        const modified = cumulativeTransformer(transformers, vid);
        if (modified) nuMedias.push(modified);
    });
    return nuMedias;
}

export interface FilterablePlaylist<MI extends MediaInfoRawData<any>, PlaylistType> extends CursoredPlaylist<MI> {


    addTransformer(filter: MediaElementTransformer<MI>): PlaylistType;
    addTransformers(filters: MediaElementTransformer<MI>[]): PlaylistType;


}